export const sanitizeGoal = goal => {
  return {
    ...goal,
    name: goal?.team?.name,
  };
};

const sumProperties = data => {
  return Object.values(data)
    .flat()
    .reduce(
      (acc, entry) => {
        acc.notes += entry.notes;
        acc.visits += entry.visits;
        acc.subscribers += entry.subscribers;
        return acc;
      },
      { notes: 0, visits: 0, subscribers: 0 }
    );
};

export const transformGoals = goals => {
  const props = sumProperties(goals);
  const month = Object.values(goals)[0][0]?.month;
  const rfv = Object.values(goals)[0][0]?.rfv;

  const obj = {
    month: new Date(month).getUTCMonth() + 1,
    visits: props?.visits,
    notes: props?.notes,
    rfv: rfv,
    subscribers: props?.subscribers,
    teams_goals: Object.values(goals).map(i => sanitizeGoal(i[0])),
  };
  return obj;
};
